<form [formGroup]="groupForm">
  <mat-form-field style="width: 100%;">
    <mat-label>{{field.name}}</mat-label>
    <mat-chip-grid #chipList>
      @for (option of selectedOptions; track option) {
        <mat-chip-row [removable] (removed)="removeOption(option)">
          <span [title]="option">{{option}}</span>
          @if (!disabled) {
            <mat-icon matChipRemove svgIcon="cancel"></mat-icon>
          }
        </mat-chip-row>
      }
      <input #optionInput formControlName="{{controlName}}" [matAutocomplete]="auto"
        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false" (matChipInputTokenEnd)="addOption($event)">
      </mat-chip-grid>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectOption($event)" panelWidth="auto">
        @if (showAutoComplete()) {
          <div>
            @for (option of filteredStudioOptions$ | async; track option?.id) {
              <mat-option  [value]="option.name">
                {{option.name}}
              </mat-option>
            }
          </div>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>

